import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const SuggestedScenarioWidget = () => {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSuggestions = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/dashboard/suggested-scenarios`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          },
        });

        if (!res.ok) throw new Error('Failed to fetch suggested scenarios');

        const data = await res.json();
        setSuggestions(data.scenarios || []);
      } catch (err) {
        console.error('Error loading suggested scenarios:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchSuggestions();
  }, []);

  const startScenario = (id) => {
    navigate('/simulator', {
      state: {
        scenarioId: id,
        isCustomScenario: false,
        fromPage: true
      }
    });
  };

  return (
    <div className="relative bg-gray-100 shadow-inner rounded-lg p-6 overflow-hidden">
      {/* Background pattern */}
      <span
        aria-hidden="true"
        style={{
          backgroundImage: "url('/patterns/bubbles.svg')",
          backgroundSize: "180%",
          opacity: 0.1,
        }}
        className="pointer-events-none absolute inset-0 bg-repeat z-0"
      />

      {/* Foreground content */}
      <div className="relative z-10">
        <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">Suggested Scenarios</h2>

        {loading ? (
          <p className="text-sm text-gray-500 animate-pulse text-center">Loading suggestions...</p>
        ) : suggestions.length ? (
          <ul className="space-y-3">
            {suggestions.map((s) => (
              <li key={s.id} className="bg-white shadow-md rounded-lg p-4">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center">
                    <p className="font-medium text-gray-800 text-sm mr-2">{s.title}</p>
                    <span
                      className={`px-2 py-0.5 text-xs font-semibold rounded-full border ${
                        s.difficulty <= 2
                          ? 'bg-green-100 text-green-800 border-green-300'
                          : s.difficulty === 3
                          ? 'bg-yellow-100 text-yellow-800 border-yellow-300'
                          : 'bg-red-100 text-red-800 border-red-300'
                      }`}
                    >
                      {s.difficulty <= 2
                        ? 'Beginner'
                        : s.difficulty === 3
                        ? 'Intermediate'
                        : 'Expert'}
                    </span>
                  </div>
                  <button
                    onClick={() => startScenario(s.id)}
                    className="px-3 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700 text-sm"
                  >
                    Start
                  </button>
                </div>
                <p className="text-gray-500 text-sm">
                  {s.summary.split(' ').slice(0, 15).join(' ')}...
                </p>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-sm text-gray-500 text-center">No scenario suggestions available yet.</p>
        )}
      </div>
    </div>
  );
};

export default SuggestedScenarioWidget;
